
import React from 'react';
import "./Footer.css"
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo-2.svg';
import playstor from '../../assets/images/playstor.svg';
import PCIDSS from '../../assets/images/PCISDSS.svg';
import isoLogo from '../../assets/images/ISOWhite.svg';
import appleStore from '../../assets/images/apple.svg';

function Component() {

  const currentDate = new Date();
const currentYear = currentDate.getFullYear();
  return (
    <footer>
      <div className="footer container flex justify-between  gap-20">
        <div className="logo">
          <Link to='/'>
            <img src={logo} alt="logo" />
          </Link>
          <p className='fs-sm-12'>A simple, secure and convenient way to make all your utility bill payments</p>
          <div className='flex  gap-20' style={{alignItems:"center", marginTop:"10px"}}>
            <a href="https://seal.panaceainfosec.com/index.php?certid=CERT8FF97A4A3A" target='_blank'>
              <img src={PCIDSS} alt="PCI DSS logo" style={{width:"120px", marginBottom:"0"}} />
            </a>
            {/* <a href="https://cerificateiso.s3.ap-south-2.amazonaws.com/Webetechies+Private+Limited.+ISO+CERTIFICATE.pdf" target='_blank'> */}
              <img src={isoLogo} alt="ISO logo" style={{width:"60px", marginBottom:"0"}} />
            {/* </a> */}
       
          </div>

        </div>
        <div className="menus flex grow-1 justify-between gap-50">
          <div className="compny">
            <h4>Our company</h4>  
            <div>
              <Link to="/dashboard">Home</Link>
              <Link to="/business">Business</Link>
              <Link to="/consumer">Consumer</Link>
              <Link to="/company">Company</Link>
              <Link to="/about-sdk">SDK</Link>
            </div>
          </div>
          {/* <div className="Payments">
            <h4>Services</h4>
              
           <div>
           <Link to="/services"></Link>
           <Link to="/services?type=mobile"> Mobile Recharge</Link>
           <Link to="/services?type=dthbill">DTH Payment</Link>
           <Link to="/services?type=electricity"> Electricity</Link>
           <Link to="/services?type=gasbill"> Gas Bill Payment</Link>
           <Link to="/services?type=emibillpayment"> EMI Payment</Link>
            
           </div>
          </div> */}
          <div className="Support">
            <h4>Support & Services</h4>
            <div>
            <Link to="/our-services">About Services</Link>
              <Link to='/faq'> FAQ </Link>             
              <Link to='/contactus'> Contact Us</Link>
              <Link to='/packages'>Plan</Link>
              <Link to='/refundpolicy'>Refund Policy</Link>

            </div>
          </div>
          <div className="Connect">
            <h4>Connect with us</h4>
            <div className="socal-icons flex">

            <div className='center'><a href="https://www.facebook.com/people/Webetechies/61554939685547/" target='-blank'><i className="fa-brands fa-facebook"></i></a></div>
            <div className='center'><a href="https://www.linkedin.com/company/web-e-techies/mycompany/verification/" target='_blank'><i className="fa-brands fa-linkedin"></i></a></div>
            <div className='center'> <a href="https://twitter.com/PvtWebetechies" target='_blank' ><i className="fa-brands fa-x-twitter"></i></a></div>
            <div className='center'><a href="https://www.instagram.com/web_e_techies/" target='_blank'><i className="fa-brands fa-instagram"></i></a></div>
             
            </div>
            <p style={{marginTop:"10px"}}></p>
            <div className="downloadMeritPay ">
            <a href='https://play.google.com/store/apps/details?id=com.webetechies.b2c' target='_blank'> <img src={playstor} alt="playstor" /></a>
            <a href='https://apps.apple.com/in/app/pay2mobiles/id6746572013' target='_blank'> <img src={appleStore} alt="playstor" /></a>
             </div>
          </div>

        </div>

      </div>
      <div className=" container footerBottom flex justify-between">
        <div className='footer-botton'>
        Copyright © {currentYear} Webetechies private limited All rights reserved.
        </div>
        <div className='footer-botton'>
        <Link to="/privacy-policy">Privacy Policy</Link> | <Link to="/terms-conditions">Terms & conditions</Link> 
        </div>

      </div>
    </footer>
  );
}

export default Component;


